const postServiceTypes = {
  toastr: 'Added Service Type',
  toastr1: ' has been successfully added',
  toastrError: 'Service Type already registered',
  toastrError1: 'Enter another name'
}

export default postServiceTypes;
